import React, { useEffect, useState } from 'react'
import GenericFormHeaderComponent from '../genericComponents/forms/GenericFormHeaderComponent';
import GenericCustomButton from '../genericComponents/GenericCustomButton';
import qz from 'qz-tray'
import GenericInput from '../genericComponents/input/GenericInputComponent';
import Icons from '../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler } from '../helper/apiHelperFunctions';
let mac64 = "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/printer_utility/mac_arm64.pkg"
let mac86 = "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/printer_utility/mac_x86_64.pkg"
let win64 = "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/printer_utility/win_arm64.exe"
let win86 = "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/printer_utility/win_x86_64.exe"
// let linux64 = "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/printer_utility/linux_arm64.run"
let linux86 = "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/printer_utility/linux_x86_64.run"

const PrintDocument = (props) => {

    let { selectedData = null, mainType = "printDocument", downloadBarcodeConfig = null } = props;

    let { checkItems = null, barcodeKey = "setBarcode" } = downloadBarcodeConfig || {};

    const [loading, setLoading] = useState({});
    const [error, setError] = useState(null);
    const [printers, setPrinters] = useState([]);

    const [currentPrinter, setCurrentPrinter] = useState(null);

    // State : To store the quantity array
    const [barcodeQuantity, setBarcodeQuantity] = useState(checkItems?.map(item => ({...item, "barcodeQuantity" : 1})))
    
    const downloadDocumentsBarcodeData = useSelector(state => state?.generalStore?.downloadDocumentsBarcodeData);

    const [localConfig, setLocalConfig] = useState({
        // to check if the file is already loaded or we need to load the file inside the printer
        isFileAvailable: mainType === "printDocument"
    })

    const dispatch = useDispatch();
    
    // Handle the response of the download barcode api
    useEffect(() => {
        if(downloadDocumentsBarcodeData?.isSuccess){
            setLoading(prev => ({...prev, "barcodeLoading": false }))
            setLocalConfig(prev => ({...prev, "isFileAvailable": true }))
        }
    },[downloadDocumentsBarcodeData?.isSuccess])

    useEffect(() => {
        connectToQz();

        return (() => {
            // Discconnect from qz
            qz?.websocket?.disconnect?.();
        })
    }, [])

    useEffect(() => {
        getPrinters()
    }, [])

    const connectToQz = async () => {
        setError(null);
        setLoading(prev => ({ ...prev, "qzConnectionLoading": true }))
        await qz?.websocket?.connect?.()?.then(res => {
            setError(null);
            setLoading(prev => ({ ...prev, "qzConnectionLoading": false }))
            getPrinters()
        })
            .catch(err => {
                console.log("Qz connection", err.message)
                setLoading(prev => ({ ...prev, "qzConnectionLoading": false }))
                console.log("PRINT ERROR1", err.message)
                setError("Unable to establish connection with the printer utility. Make sure you have printer utility software installed on your system; if not, please download from the list below or try reinstalling the program.");
            })
    }

    const getPrinters = () => {
        if (qz) {
            setError(null);
            setLoading(prev => ({ ...prev, "fetchPrinters": true }));
            qz?.printers?.find?.()?.then(p => {
                console.log("Eror 1", p);
                setPrinters(p);
                if (!currentPrinter) {
                    setCurrentPrinter(p?.[0]);
                }
                setLoading(prev => ({ ...prev, "fetchPrinters": false }));
            })
                .catch(err => {
                    console.log("Eror 1", err);
                    setLoading(prev => ({ ...prev, "fetchPrinters": false }));
                    console.log("PRINT ERROR2", err.message)
                    setError("Unable to fetch the printers. Make sure you have printer utility software installed on your system; if not, please download from the list below or try reinstalling the program.");
                })
        }
    }

    const printBarcode = () => {

        setLoading((prev) => ({ ...prev, "printFile": true }));
        setError(null);

        fetch(selectedData?.url)
            .then((res) => res.text())
            .then((newText) => {
                console.log("PORT32", newText)
                var config = qz?.configs?.create(currentPrinter?.printer);
                var data = [{
                    type: "raw",
                    "data": newText
                }]
                return qz?.print(config, data)
            })
            .catch((err) => {
                console.log("PRINT ERROR3", err.message)
                setError("Unable to print the barcode. Make sure you have printer utility software installed on your system; if not, please download from the list below or try reinstalling the program.");
                setLoading((prev) => ({ ...prev, "printFile": false }));
            }
            );
        setLoading((prev) => ({ ...prev, "printFile": false }));
    }

    // Function : To print the printer data here
    const renderPrinterData = () => {


        let printerData = [
            { os: "Windows", type: "x86", link: win86 },
            { os: "Windows", type: "arm64", link: win64 },
            { os: "Mac OS", type: "x86", link: mac86 },
            { os: "Mac OS", type: "arm64", link: mac64 },
            { os: "Linux", type: "x86", link: linux86 },
        ]

        let isConnected = qz?.websocket?.isActive();
        // console.log("Is connected", isConnected)
        if (isConnected && !loading?.["qzConnectionLoading"]) {

            // Render the printer list and the print button

            return <div className={`flex flex-col items-start text-start w-full ${mainType === "downloadAndPrint" ? 'h-full overflow-auto' : ''}`}>

                {!error && <p className={`text-[#20BF6B] text-xs font-medium flex items-center gap-2 ${mainType === "downloadAndPrint" ? 'px-[15px]' : 'px-6'}`}>
                    <svg width="17" height="17" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_31545_23907)">
                            <path d="M3.87813 12.7495C0.790625 9.66198 0.790625 4.59531 3.87813 1.50781" stroke="#20BF6B" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.17577 3.71875C5.42472 4.49694 4.95464 5.50338 4.83993 6.57879C4.72522 7.6542 4.97243 8.73715 5.54243 9.65625" stroke="#20BF6B" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.5013 8.70573C10.3758 8.70573 11.0846 7.99685 11.0846 7.1224C11.0846 6.24794 10.3758 5.53906 9.5013 5.53906C8.62685 5.53906 7.91797 6.24794 7.91797 7.1224C7.91797 7.99685 8.62685 8.70573 9.5013 8.70573Z" stroke="#20BF6B" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.8242 3.79688C14.4076 5.38021 14.6134 7.84229 13.4576 9.71063" stroke="#20BF6B" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.1211 1.50781C15.855 2.24021 16.4372 3.11016 16.8345 4.06787C17.2318 5.02558 17.4363 6.05223 17.4363 7.08906C17.4363 8.1259 17.2318 9.15255 16.8345 10.1103C16.4372 11.068 15.855 11.9379 15.1211 12.6703" stroke="#20BF6B" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.51953 14.25H11.4779" stroke="#20BF6B" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.33203 17.4193L9.4987 8.71094L12.6654 17.4193" stroke="#20BF6B" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_31545_23907">
                                <rect width="19" height="19" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>

                    Connection Established with Printer utility</p>}
                <div className={`printBarcodeList mt-10 mb-16 w-full ${mainType === "downloadAndPrint" ? 'downloadAndPrint h-full px-[15px]' : 'printBarcodeListWrapper px-6'}`}>
                    <GenericInput
                        label={() => (<p className={`font-semibold text-[#0F172A] mb-1`}>Choose Printer</p>)}
                        key={'choosePrinter'}
                        iconRight={<Icons.DownArrowNew />}
                        value={currentPrinter?.printer}
                        type="dropdown"
                        disabled={loading?.["printFile"]}
                        onChange={(val) => setCurrentPrinter(val || null)}
                        inputProps={() => ({
                            getListData: () => printers?.map(item => ({ "printer": item })),
                            headerKeys: {
                                "printer": {}
                            },
                            itemKeys: {
                                "printer": ["printer"]
                            }
                        })}
                        placeholder='Search from available list'
                        iconLeft={
                            <span className='mr-2 ml-1'>
                                <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_31545_23923)">
                                        <path d="M4.5 13.5H3C2.60218 13.5 2.22064 13.342 1.93934 13.0607C1.65804 12.7794 1.5 12.3978 1.5 12V8.25C1.5 7.85218 1.65804 7.47064 1.93934 7.18934C2.22064 6.90804 2.60218 6.75 3 6.75H15C15.3978 6.75 15.7794 6.90804 16.0607 7.18934C16.342 7.47064 16.5 7.85218 16.5 8.25V12C16.5 12.3978 16.342 12.7794 16.0607 13.0607C15.7794 13.342 15.3978 13.5 15 13.5H13.5" stroke="black" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4.5 6.75V2.25C4.5 2.05109 4.57902 1.86032 4.71967 1.71967C4.86032 1.57902 5.05109 1.5 5.25 1.5H12.75C12.9489 1.5 13.1397 1.57902 13.2803 1.71967C13.421 1.86032 13.5 2.05109 13.5 2.25V6.75" stroke="black" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M12.75 10.5H5.25C4.83579 10.5 4.5 10.8358 4.5 11.25V15.75C4.5 16.1642 4.83579 16.5 5.25 16.5H12.75C13.1642 16.5 13.5 16.1642 13.5 15.75V11.25C13.5 10.8358 13.1642 10.5 12.75 10.5Z" stroke="black" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_31545_23923">
                                            <rect width="18" height="18" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                        }
                        inputDropdownExtraClass='placeholder:font-normal rounded-none'
                    />
                    <div className='flex items-center gap-2 text-xs'>
                        <span className='text-[#67768E]'>Unable to find your printer ?</span>
                        <GenericCustomButton className={'!font-semibold !text-[#0F172A] !ml-0 !h-fit !border-none !p-[0] hover:opacity-75'} disabled={loading?.["fetchPrinters"]} label="Refetch Printers list" onClick={() => getPrinters()} />
                    </div>
                </div>
                {
                    currentPrinter?.printer &&
                    <div className={`w-full ${mainType === "downloadAndPrint" ? 'px-[15px]' : 'mb-3 px-6'}`}>
                        <GenericCustomButton
                            sendEventAnalyticsToGoogle = {true}
                            label="Print Barcode"
                            onClick={() => printBarcode()}
                            type='primary'
                            disabled={!currentPrinter?.printer || loading?.["printFile"]}
                            className={`mb-2 w-full rounded-none !h-[35px] justify-center !ml-0 ${mainType === "downloadAndPrint" ? 'px-[15px]' : 'px-6'}`}
                        />
                    </div>
                }
            </div>

        } else {
            return <div className={`flex flex-col items-center w-full ${mainType === "downloadAndPrint" ? 'flex-grow' : ''}`}>
                <div className={`w-full mt-1 ${mainType === "downloadAndPrint" ? 'px-[15px]' : 'px-6'}`}>

                    <GenericCustomButton
                        label="Establish Connection with Printer Utility"
                        onClick={() => connectToQz()}
                        loading={loading?.["qzConnectionLoading"]}
                        // type='primary'
                        className={`!border !border-[#B7C6DE] !bg-none rounded-none !w-full !p-[9px] !text-fontBlack !font-medium !text-[13px] justify-center !text-center ${mainType === 'downloadAndPrint' ? '!ml-0 !h-[34px]' : ''} !hover:opacity-75`}
                    />
                </div>

                <div className={`border-t border-[#DAE4EE] pt-[12px] pb-4 flex flex-col items-center w-full mt-5 ${mainType === "downloadAndPrint" ? 'flex-grow' : 'sticky bottom-0 left-0 !z-[9999]'} bg-white`}>
                    <p className={`text-xs text-[#0F172A] ${mainType === "downloadAndPrint" ? 'px-[15px]' : 'px-6'}`}>Please download Printer Utility to print the document</p>
                    <div className={`w-full text-xs overflow-y-auto ${mainType === "downloadAndPrint" ? 'h-full' : 'max-h-[200px]'}`}>

                        <table className="min-w-full">
                            <thead className="sticky top-0 bg-gray-50 z-[999]">
                                <tr>
                                    <th className='py-2'>OS</th>
                                    <th className='py-2'>OS Type</th>
                                    <th className='py-2'>Download</th>
                                </tr>
                            </thead>
                            <tbody className='mt-2' >
                                <tr className="block h-4"></tr>

                                {printerData?.map(item => (
                                    <tr>
                                        <td className="py-1">{item?.os}</td>
                                        <td className="py-1">{item?.type}</td>
                                        <td className="py-1"><GenericCustomButton
                                            className={'!mx-auto'}
                                            type='default'
                                            label="Download"
                                            onClick={() => {
                                                var a = document.createElement('a');
                                                a.target = '_blank'
                                                a.href = item?.link;
                                                a.innerText = 'printer_utility';
                                                a.download = item?.link;

                                                document.body.appendChild(a);
                                                a.click()
                                            }}
                                        /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        }

    }

    const renderPrintBarcodeQtyInputContainer = () => {

        if(!barcodeKey || !checkItems) return null

        return (
            <div className='h-full px-[15px] flex flex-col w-2/5 border-r border-borderSlateGrey'>
                <div className='h-full'>
                    <table className='w-full'>
                        <thead>
                            <tr>
                                <th className='py-2 pr-3'>Barcode</th>
                                <th className='py-2'>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                barcodeQuantity?.map((item, index) => (
                                    <tr> 
                                        <td className='pr-3'><div className='px-1.5 py-1 h-[32px] bg-borderSlateGrey rounded text-xs font-semibold text-[#23235f] border border-borderSlateGrey flex items-center'><span>{item?.[barcodeKey]}</span></div></td>
                                        <td>
                                            <GenericInput
                                                genInputExtraClass="!mb-0"
                                                // inputClassName="!h-[34px]"
                                                key="search"
                                                placeholder="Search module name"
                                                type="number"
                                                min={0}
                                                onChange={(e) => {
                                                    let val = e?.target?.value;
                                                    let updatedBarcodeQuantity = [...barcodeQuantity];
                                                    updatedBarcodeQuantity[index].barcodeQuantity = val;
                                                    setBarcodeQuantity(updatedBarcodeQuantity)
                                                }}
                                                value={item?.barcodeQuantity}
                                                />
                                            {/* <input onChange={(e) => {
                                            let val = e?.target?.value;
                                            let updatedBarcodeQuantity = [...barcodeQuantity];
                                            updatedBarcodeQuantity[index].barcodeQuantity = val;
                                            setBarcodeQuantity(updatedBarcodeQuantity)
                                        }} type='number' value={item?.barcodeQuantity} min={0}/> */}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                {/* render the download button */}
                <div className='flex items-center gap-3'>
                    <GenericCustomButton
                        type='default'
                        label="Reset"
                        disabled={downloadDocumentsBarcodeData?.isLoading}
                        onClick={() => {
                            setBarcodeQuantity(checkItems?.map(item => ({...item, barcodeQuantity : 1})))
                        }}
                        className={`!ml-0 mb-2 w-full rounded-none !h-[35px] justify-center !text-center ${mainType === "downloadAndPrint" ? 'px-[15px]' : 'px-6'}`}
                    />
                    <GenericCustomButton
                        type = "primary"
                        label = "Confirm"
                        loading={downloadDocumentsBarcodeData?.isLoading}
                        onClick={() => {
                            // Download the actual file here and load that file to printer
                            downloadFunction({
                                "item" : downloadBarcodeConfig?.item,
                                "type": "FALSE",
                                "downloadFile" : true,
                                "barcodeQuantity" : barcodeQuantity,
                            })
                        }}
                        className={`!ml-0 mb-2 w-full rounded-none !h-[35px] justify-center !text-center ${mainType === "downloadAndPrint" ? 'px-[15px]' : 'px-6'}`}
                    />
                </div>
            </div>
        )
    }

    // Function : To download the file to print the barcode
    const downloadFunction = (config) => {
        if (downloadDocumentsBarcodeData?.isLoading) return;

        let { item, type, } = downloadBarcodeConfig || {};

        let idKey = item?.["documentId"] || "shipmentId";
        let idDocumentNumber = item?.["documentNo"] || "shipmentAdviceCode";

        // Handle the case: Do we need to print the download documents or just download the file.
        if (idKey && idDocumentNumber) {
            let payload = {
                "data": barcodeQuantity?.map((item, index) => ( !isNaN(Number(item?.["barcodeQuantity"] || "")) && Number(item?.["barcodeQuantity"] || "") > 0 ?  {
                    "documentId": item?.[idKey] || "",
                    "documentNo": item?.[idDocumentNumber] || "",
                    "quantity" : item?.["barcodeQuantity"]
                } : null))?.filter(item => Boolean(item)) || [],

                "filters": item?.["filters"] ? item?.["filters"] : {},
                "type": item?.key || "",
                "disposition": type
            }
            // Download the document data
            dispatchHandler(dispatch, "downloadDocumentsBarcodeRequest", payload)
        }
    }
    return (
        <div className={`${mainType == "downloadAndPrint" ? 'h-full' : ''}`}>
            {/* <div className='px-[8px] sticky top-0 left-0 !z-[9999] w-full bg-white border-b border-[#DAE4EE]'> */}
                <GenericFormHeaderComponent
                    label={{
                        contentPrimary: mainType == "downloadAndPrint" ? `Download and Print Barcode`  : `Print Barcode`,
                        contentSecondry: <div className='flex items-center gap-2'>
                            <p>{selectedData?.fileName}</p>
                            {selectedData?.url &&
                                <GenericCustomButton
                                    label="Download"
                                    className='bg-none rounded-none p-[2px] font-medium text-[13px] hover:opacity-75 text-primary'
                                    onClick={() => {
                                        window.open(selectedData?.url || "")
                                    }}
                                />
                            }
                        </div>,
                    }}
                    closeModal={() => props.closeModal()}
                />
            {/* </div> */}
            <div className={`${mainType == "downloadAndPrint" ? 'h-[calc(100%-65px)] flex items-start' : ''}`}>
                {/* Render the print barcode qty input */}
                {mainType === "downloadAndPrint" && renderPrintBarcodeQtyInputContainer()}

                {/* TODOt : @Vishnu Please add the overlay on the right side data */}
                <div className={`text-fontBlack ${mainType === "downloadAndPrint" ? 'h-full w-3/5 overflow-auto' : ''}`}>
                    {/* Condition : isFileAvailable ? available : unavailable */}
                    <div className={`flex flex-col gap-2 items-center text-center ${mainType === "downloadAndPrint" ? 'h-full pt-[8px]' : 'pt-4'}`}>
                        <div className={`mt-1 w-full ${mainType === "downloadAndPrint" ? 'px-[15px]' : 'px-6'}`}>
                            <p className='w-full flex items-center gap-2.5 p-[10px] bg-[#E7F1FF] text-xs font-medium text-start'>
                                <svg width="15" height="15" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9414 8.32812C16.9414 3.90985 13.3597 0.328125 8.94141 0.328125C4.52313 0.328125 0.941406 3.90985 0.941406 8.32812C0.941406 12.7464 4.52313 16.3281 8.94141 16.3281C13.3597 16.3281 16.9414 12.7464 16.9414 8.32812ZM9.94141 4.32812C9.94141 3.77584 9.49369 3.32812 8.94141 3.32812C8.38912 3.32812 7.94141 3.77584 7.94141 4.32812C7.94141 4.88041 8.38912 5.32812 8.94141 5.32812C9.49369 5.32812 9.94141 4.88041 9.94141 4.32812ZM8.94141 13.3281C8.38912 13.3281 7.94141 12.8804 7.94141 12.3281V8.32812C7.94141 7.77584 8.38912 7.32812 8.94141 7.32812C9.49369 7.32812 9.94141 7.77584 9.94141 8.32812V12.3281C9.94141 12.8804 9.49369 13.3281 8.94141 13.3281Z" fill="#116FFF" />
                                </svg>

                                The Printer Utility should be running in the background!
                            </p>
                            {error && <p className='text-red-500 text-xs font-medium text-start' >{error}</p>}

                        </div>


                        {renderPrinterData()}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default PrintDocument